/* eslint-disable @typescript-eslint/no-explicit-any */
import { SuccessClientResponse } from '@orbis-systems/orbis-api-clients';
import { Account, Group, Portfolio } from '@orbis-systems/orbis-api-middleware';
import { queryOptions } from '@tanstack/react-query';
import { orbis } from '../api';

export type GroupListingResponse = SuccessClientResponse<Group[]>;
export type GroupPortfolioResponse = SuccessClientResponse<Portfolio>;
export type GroupAccountsStatsResponse = SuccessClientResponse<Account[]>;
export interface GroupPortfolioQueryParams {
    groupId: number;
    currency?: string;
    /**
     * Should load quotes or not.
     * @example "false"
     */
    loadQuotes?: any;
    /**
     * Whether to return combined portfolio (no accounts, with approximate prices)
     * @example "false"
     */
    combined?: any;
    /** @example "false" */
    loadIndustries?: any;
    /** @example "false" */
    loadUpgrades?: any;
    /** @example "false" */
    loadEarnings?: any;
    /**
     * Whether or not to include orders comprising each position's cost
     * @example "false"
     */
    loadCost?: any;
    /**
     * Analyze market caps and get `marketCapWeights`. To be used in conjuction with `loadQuotes`
     * @example "false"
     */
    marketCapWeights?: any;
    /** @example "1" */
    pageNum?: any;
    /** @example "100" */
    pageSize?: any;
}

export const groupQueries = {
    all: () => queryOptions({ queryKey: ['groups'] }),
    groupsList: () =>
        queryOptions<GroupListingResponse>({
            queryKey: [...groupQueries.all().queryKey, 'groupsList'],
            queryFn: () => orbis.advisory.groups.groupsList(),
        }),
    groupPortfolios: (params: GroupPortfolioQueryParams) => {
        const { groupId, ...rest } = params;
        return queryOptions<GroupPortfolioResponse>({
            queryKey: [...groupQueries.all().queryKey, 'groupPortfolios', groupId, rest],
            queryFn: () => orbis.advisory.groups.groupPortfolios(String(groupId), { ...rest }),
        });
    },
    groupAccountsStats: (groupId: string) =>
        queryOptions<GroupAccountsStatsResponse>({
            queryKey: [...groupQueries.all().queryKey, 'groupAccountsStats', groupId],
            queryFn: () => orbis.advisory.groups.groupAccountsStats(groupId),
        }),
};
